import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { infoLinks } from '../../shared/utils/home';

export default function ButtonBox({ buttons = infoLinks }: { buttons?: Props.ButtonBox[] }) {
  const { t } = useTranslation();
  return (
    <div className="button-box">
      {buttons.map(item => (
        <Link href={item.link} key={item.key}>
          <a className="button-box-item pl-lg mt-lg">
            <div className="button-box-item-icon" aria-hidden="true">
              {item.icon}
            </div>
            <div className="button-box-item-text">{t(item.text)}</div>
          </a>
        </Link>
      ))}
    </div>
  );
}
